import ImagePerson from "@/components/functionals/ImagePerson";
import ColorOfTasks from "@/components/internal_requests/KPI/TasksReport/ColorOfTasks";
// import ColorsForProductivityAndNonProductivity from "@/components/functionals/ProductivityHour/ColorsForProductivityAndNonProductivity";
import LinkdialogOpener from "@/components/functionals/ProductivityHour/LinkdialogOpener";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter";
import TipoRequestsTasksFormater from "@/components/ProductivityByMonthReport/TasksAndRequests/TipoRequestsTasksFormater.vue";

const columns = (thiss) => [
  {
    prop: "ResponsibleName",
    label: "Colaborador",
    "min-width": 200,
    sortable: true,
    fixed: true,
    formatter: ImagePerson,
    attrs: {
      imgKey: "ResponsiblePhoto"
    }
    //formatter: HyperlinkForModuleVacations
  },

  // {
  //   prop: "TotalHours",
  //   label: "Horas",
  //   align: "center",
  //   "min-width": 100,
  //   sortable: true
  //   //formatter: HyperlinkForModuleVacations
  // },
  {
    prop: "January",
    label: "Enero",
    align: "center",
    "min-width": 80,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    // formatter: (row, column, rowValue) => (
    //    <LinkdialogOpener rowValue={rowValue} row={row} column={column} call={thiss.OpenDialodDetailList} />
    // )
  },
  {
    prop: "February",
    label: "Febrero",
    align: "center",
    "min-width": 80,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "March",
    label: "Marzo",
    align: "center",
    "min-width": 70,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "April",
    label: "Abril",
    align: "center",
    "min-width": 70,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "May",
    label: "Mayo",
    align: "center",
    "min-width": 70,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "June",
    label: "Junio",
    align: "center",
    "min-width": 70,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "July",
    label: "Julio",
    align: "center",
    "min-width": 70,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "August",
    label: "Agosto",
    align: "center",
    "min-width": 80,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "September",
    label: "Septiembre",
    align: "center",
    "min-width": 100,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "October",
    label: "Octubre",
    align: "center",
    "min-width": 80,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "November",
    label: "Noviembre",
    align: "center",
    "min-width": 100,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "December",
    label: "Diciembre",
    align: "center",
    "min-width": 100,
    // sortable: true,
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(LinkdialogOpener, {
        props: {
          rowValue,
          row,
          column,
          call: thiss.OpenDialodDetailList
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  }
  // {
  //   prop: "OverallProductivityPercentage",
  //   label: "Productividad",
  //   align: "center",
  //   "min-width": 150,
  //   sortable: true,
  //   formatter: (row, column, rowValue) => {
  //     const createElement = thiss.$createElement;
  //     return createElement(ColorsForProductivityAndNonProductivity, {
  //       props: {
  //         row,
  //         column,
  //         rowValue
  //       }
  //     });
  //   }
  //   // formatter: (row) => {
  //   //   return row.OverallProductivityPercentage.toFixed(2) + " %";
  //   // }
  // },

  // {
  //   prop: "RemainingHours",
  //   label: "Horas no productivas",
  //   align: "center",
  //   "min-width": 190,
  //   sortable: true,
  //   formatter: (row, column, rowValue) => {
  //     const createElement = thiss.$createElement;
  //     return createElement(ColorsForProductivityAndNonProductivity, {
  //       props: {
  //         row,
  //         column,
  //         rowValue
  //       }
  //     });
  //   }
  //   //formatter: HyperlinkForModuleVacations
  // }
];

const TasksAndRequestColumns = (thiss) => [
  {
    prop: "Id",
    label: "No. (Solicitud / Tarea)",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: ColorOfTasks
  },
  {
    prop: "Type",
    label: "Tipo (Solicitud / Tarea)",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: (row, column, rowValue) => {
      const createElement = thiss.$createElement;
      return createElement(TipoRequestsTasksFormater, {
        props: {
          rowValue,
          row,
          column
        }
      });
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "ShorDescription",
    label: "Descripción",
    "min-width": 200,
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "ResponsibleName",
    label: "Responsable",
    "min-width": 130,
    sortable: true,
    formatter: ImagePerson,
    attrs: {
      imgKey: "ResponsiblePhoto"
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "CreatorName",
    label: "Creador",
    "min-width": 130,
    sortable: true,
    formatter: ImagePerson,
    attrs: {
      imgKey: "CreatorPhoto"
    }
    //formatter: HyperlinkForModuleVacations
  },
  {
    prop: "TimeOntask",
    label: "Tiempo",
    "min-width": 50,
    align: "center",
    sortable: true
    //formatter: HyperlinkForModuleVacations
  },
  // {
  //   prop: "DelayedDays",
  //   label: "Rettraso",
  //   "min-width": 100,
  //   sortable: true
  //   //formatter: HyperlinkForModuleVacations
  // },
  {
    prop: "closeDate",
    label: "Fecha de cierre",
    "min-width": 100,
    sortable: true,
    align: "center",
    formatter: DatetimeFormatter
    //formatter: HyperlinkForModuleVacations
  }
  // {
  //   prop: "DueDate",
  //   label: "Fecha de compromiso",
  //   "min-width": 100,
  //   sortable: true,
  //   align: "center",
  //   formatter: DatetimeFormatter
  //   //formatter: HyperlinkForModuleVacations
  // }
];

const TasksAndRequestsActions = [
  {
    icon: "el-icon-view",
    label: "Ver Detalle",
    command: "view_task"
  }
];

export { columns, TasksAndRequestColumns, TasksAndRequestsActions };
